<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>{{ '+SRC_COMMISSIONINGV2.ADD_COMPONENT_HEADER' | translate }}</span>
      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <div class="content__img-section">
        <img
          class="flex-1"
          src="./assets/img/commissioningv2/device-black-{{
            (commissioningService.selectedDevice$ | async).icon
          }}.png"
          alt=""
        />
      </div>

      <div class="content__description-section">
        <div class="description-section__header">
          {{ '+SRC_COMMISSIONINGV2.REMINDER_MODAL_CHECK_PREPARATION' | translate }}
        </div>
        <div
          class="description-section__text"
          *ngIf="commissioningService.selectedDevice$ | async as device"
        >
          <ng-container [ngSwitch]="device.type">
            <ng-container *ngSwitchCase="remoteDeviceType.FHT">
              <div class="instructions-wrapper">
                <div class="instructions-description">
                  {{ '+SRC_COMMISSIONINGV2.MESSAGE_FHT_DESCRIPTION' | translate }}
                </div>
                <div class="instructions-content">
                  <div class="instruction-option">
                    <div class="order">1.1</div>
                    <div>{{ '+SRC_COMMISSIONINGV2.MESSAGE_FHT_STEP_NOTE' | translate }}</div>
                  </div>
                  <div class="instruction-option">
                    <div class="order">1.2</div>
                    <div>
                      {{ '+SRC_COMMISSIONINGV2.MESSAGE_FHT_STEP_SENSOR_CONNNECTION' | translate }}
                    </div>
                  </div>
                  <div class="instruction-option">
                    <div class="order">1.3</div>
                    <div>
                      {{ '+SRC_COMMISSIONINGV2.MESSAGE_FHT_STEP_ANTENA_CONNNECTION' | translate }}
                    </div>
                  </div>
                  <div class="instruction-option">
                    <div class="order">1.4</div>
                    <div>
                      {{ '+SRC_COMMISSIONINGV2.MESSAGE_FHT_STEP_POWER_CONNNECTION' | translate }}
                    </div>
                  </div>
                  <div class="instruction-option">
                    <div class="order">1.5</div>
                    <div>
                      {{ '+SRC_COMMISSIONINGV2.MESSAGE_FHT_STEP_PROTECTIVE_CONTACT' | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="remoteDeviceType.CS_REPEATER">
              {{ '+SRC_COMMISSIONINGV2.MESSAGE_REMOVED_BATTERY' | translate }}
            </ng-container>
            <ng-container *ngSwitchCase="remoteDeviceType.REPEATER">
              {{ '+SRC_COMMISSIONINGV2.MESSAGE_IN_WALL_RANGE_EXTENDER' | translate }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{
                '+SRC_COMMISSIONINGV2.MESSAGE_PLACE_BATTERY_IN_DEVICE'
                  | translate: { deviceName: device.name | translate }
              }}
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      gtm="onConfirm"
      gtmAction="Navigate Back"
      gtmCategory="reminderModal"
      mat-stroked-button
      color="primary"
      (click)="navigateBack()"
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
    <button
      gtm="onConfirm"
      gtmAction="Navigate Forward"
      gtmCategory="reminderModal"
      mat-raised-button
      color="primary"
      (click)="navigateForward()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
